import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const IS_DEV = process.env.NODE_ENV !== "production";
export const logError = (...args) => { if (IS_DEV) console.error(...args); };

// Cookie-based auth — tokens live in httpOnly cookies set by backend.
// Enable sending/receiving credentials for all axios requests by default.
axios.defaults.withCredentials = true;

export { axios };
